import { render, staticRenderFns } from "./PetCategories.vue?vue&type=template&id=30aa855c&scoped=true&"
import script from "./PetCategories.vue?vue&type=script&lang=js&"
export * from "./PetCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa855c",
  null
  
)

export default component.exports